import { formatISO, parse } from "date-fns";

export function toStringISODate(date) {
  return formatISO(date, {
    representation: "date",
  });
}

export function toStringISODateTime(date) {
  return formatISO(date, {
    representation: "complete",
  });
}

export function parseDate(date, format = "d/M/y", locale) {
  if (!locale) locale = navigator.language;
  const options = { weekStartsOn: 1, locale };

  return parse(date, format, new Date(), options);
}
